export default __webpack_public_path__ + "static/media/whatsapp.184816f1.svg";